// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const metricInAfterOneMax = 80;

export const metricInBeforeOneMax = 80;

export const metricInLabelMax = 200;

export const metricInUnitOneMax = 40;

export const metricInValueOneMax = 80;

export const MetricIn = zod.object({
  "after": zod.union([zod.string().max(metricInAfterOneMax),zod.null()]).optional(),
  "before": zod.union([zod.string().max(metricInBeforeOneMax),zod.null()]).optional(),
  "label": zod.string().min(1).max(metricInLabelMax),
  "provenance": zod.enum(['client_measured', 'self_measured', 'expected']),
  "unit": zod.union([zod.string().max(metricInUnitOneMax),zod.null()]).optional(),
  "value": zod.union([zod.string().max(metricInValueOneMax),zod.null()]).optional()
});

export type MetricIn = zod.input<typeof MetricIn>;
export type MetricInOutput = zod.output<typeof MetricIn>;
